import React from "react";
import "./styles.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/brands.css";
import "@fortawesome/fontawesome-free/css/solid.css";

import Home from "./components/Home";
export default function App(){
  return(
    <div  className="App">
    <Home />
    </div>
  );}
